import { useEffect } from 'react';

export const usePasswordInputReset = ({ inputRef, handleShowPasswordChange, resetDependencies }) => {
    useEffect(() => {
        handleShowPasswordChange(false);
        if (inputRef.current) inputRef.current.value = '';
    }, resetDependencies);
};
